import { CrudManager } from "./crud";

export default function IntranetAdmin() {
  return (
    <div className="space-y-12" data-testid="intranet-admin">
      <CrudManager coll="announcements" title="Comunicados"
        fields={[
          { key: "title", label: "Título", type: "i18n" },
          { key: "body", label: "Contenido", type: "i18n-textarea", rows: 5 },
          { key: "order", label: "Orden", type: "number" },
          { key: "active", label: "Activo", type: "switch" },
        ]}
        columns={[{ key: "title", label: "Título" }, { key: "active", label: "Activo" }]} />
      <CrudManager coll="quicklinks" title="Enlaces rápidos"
        fields={[
          { key: "name", label: "Nombre", type: "text" },
          { key: "url", label: "URL", type: "text" },
          { key: "order", label: "Orden", type: "number" },
          { key: "active", label: "Activo", type: "switch" },
        ]}
        columns={[{ key: "name", label: "Nombre" }, { key: "url", label: "URL" }, { key: "active", label: "Activo" }]} />
      <CrudManager coll="intranet_docs" title="Documentación / Procedimientos / Manuales"
        fields={[
          { key: "title", label: "Título", type: "i18n" },
          { key: "description", label: "Descripción", type: "i18n" },
          { key: "url", label: "Archivo / URL", type: "media" },
          { key: "order", label: "Orden", type: "number" },
          { key: "active", label: "Activo", type: "switch" },
        ]}
        columns={[{ key: "title", label: "Título" }, { key: "url", label: "URL" }, { key: "active", label: "Activo" }]} />
    </div>
  );
}
